<template>
      <div class="layout-wrapper">
        <div class="main-menu" id="sidebarMenu">
            <div class="logo-box">
                <a href="javascript:void(0)"  class=" mt-3">
                    <img :src="getUrl(profile?.Image, logo_default)" alt="logo" class="logo-xl mb-4 h-25 ms-n4 me-2 avatar-md">
                   <span class="fs-1 me-5 ">
                        <span v-for="(word, index) in nameWords" :key="index" class="me-1 fw-bold">
                            <span :class="bootstrapColors[index % bootstrapColors.length]">
                           {{ word.charAt(0) }}
                         </span>
                      </span>
                    </span>
                </a>
            </div>
            <div  ref="scrollContainer" data-simplebar class>
              <div class="simplebar-wrapper" style="margin: 0px;">
                <div class="simplebar-height-auto-observer-wrapper">
                  <div class="simplebar-height-auto-observer"></div></div>
                  <div class="simplebar-mask">
                    <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                      <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style="height: 100%; overflow: hidden scroll;"><div class="simplebar-content" style="padding: 0px;">
                    <ul class="app-menu" id="sidebarAccordion">
  
  <li v-for="(item, index) in sidebarLinks" :key="index" class="menu-item"  :class="{ 'active-menu': isActive(item) }">
    <template v-if="item.children">
      <a 
        href="javascript:void(0);" 
        class="menu-link waves-effect cursor-pointer" 
        data-bs-toggle="collapse" 
        :aria-expanded="false" 
        :data-bs-target="`#menuCollapse${index}`"
      >
        <span class="menu-icon">
          <i :class="item.icon"></i>
        </span>
        <span class="menu-text">{{ item.label }}</span>
        <span class="menu-arrow"></span>
      </a>

      <div 
        class="collapse" 
        :id="`menuCollapse${index}`"
        data-bs-parent="#sidebarAccordion"
      >
        <ul class="sub-menu ms-4">
          <li 
            v-for="(sub, idx) in item.children" 
            :key="idx" 
            class="menu-item cursor-pointer" :class="{ 'active-menu': isActive(sub) }"
          >
            <router-link :to="sub.path" class="menu-link">
              <span class="menu-icon">
                <i :class="sub.icon"></i>
              </span>
              <span class="menu-text">{{ sub.label }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <router-link :to="item.path" class="menu-link waves-effect">
        <span class="menu-icon">
          <i :class="item.icon"></i>
        </span>
        <span class="menu-text">{{ item.label }}</span>
      </router-link>
    </template>

  </li>
</ul>

            </div></div></div></div>
            <div class="simplebar-placeholder" style="width: auto; height: 1066px;"></div>
          </div>
          <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
            <div class="simplebar-scrollbar" style="width: 0px; display: none; transform: translate3d(0px, 0px, 0px);"></div></div>
           <div class="simplebar-track simplebar-vertical" style="visibility: visible; z-index:9999;">
            <div class="simplebar-scrollbar simplebar-visible" >
            
           </div></div></div>
        </div>
        <div class="page-content">
            <div class="navbar-custom">
                <div class="topbar bg-white h-75 border-bottom-light">
                    <div class="topbar-menu d-flex align-items-center gap-lg-2 gap-1">
                        <button class="button-toggle-menu waves-effect waves-dark rounded-circle" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" @click="toggleSidebar">
                            <i class="mdi mdi-menu"></i>
                        </button>
                    </div>
                    <div class="topbar-menu d-flex align-items-center gap-lg-2 gap-1 topbar-a">
                      <p class="mt-3 ms-5 d-none d-md-block"> Call For Support : <a href="tel:9581081277" class="color-darknavy"><strong>+91 95810 81277</strong></a> </p>
                      <a href="tel:9581081277" class="d-block d-md-none text-danger"> <i class="fas fa-phone-volume"></i> </a>
                    </div>
                    
                    <ul class="topbar-menu d-flex align-items-center gap-2 topbar-a">
                       
                        <li class="d-none d-md-inline-block">
                            <a class="nav-link waves-effect waves-dark" href="#" @click="toggleFullscreen">
                                <i class="mdi mdi-fullscreen font-size-24"></i>
                            </a>
                        </li>
                         <li class="d-none d-md-inline-block">
                            <a class="nav-link waves-effect waves-dark" href="#" role="button" data-bs-toggle="modal"
                data-bs-target="#document-modal" aria-hidden="true">
                                <i class="fas fa-image fs-4 cursor-pointer"></i>
                            </a>
                        </li>
                        <li class="dropdown">
                            <a class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-dark" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                              <img  :src="getUrl(Profiles.image, profile_default)" class="rounded-circle" alt="user avatar" />
                                <span class="user-name ms-1">
                                  {{ Profiles.name }}<i class="mdi mdi-chevron-down"></i>
                                </span> 
                            </a>

                            <div class="dropdown-menu dropdown-menu-end profile-dropdown ">
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">Welcome !</h6>
                                </div>
                                 <div class="dropdown-divider"></div>
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                               <router-link :to="`/profile`"> <div class="menu-title text-dark"><i class="fa fa-user mb-1"></i> Profile</div> </router-link></a>
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <router-link :to="`/login`"> <div class="menu-title text-dark"><i class="fa fa-sign-out mb-1"></i> Logout</div> </router-link> </a>

                            </div>
                        </li>

                    </ul>
                </div>
            </div>
            <div class="px-3">
                <div class="container-fluid">
                   <div class="page-inner">
                    <div class="page-title">
                    </div>
                <div id="main-wrapper">
                    <div class="row marl-5">
                         <router-view />
                    </div>
                </div>
                <div class="page-footer">                
                </div>
                </div>
            
                    </div>
                </div>
            </div>
        </div>
<div id="document-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="document-modalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body position-relative">
        <div class="capture-a" v-show="true">
          <CapturePhoto ref="captureRef" :autoStart="false" :dwnloadfileName="'Document'" />
        </div>
 <div class="row">
  <div class="col-12 col-md-6">
    <DocScanner />
  </div>
  <div class="col-12 col-md-6">
    <div class="d-flex justify-content-end align-items-center gap-2 mt-3 me-3">
      <input type="checkbox" class="form-check-input" v-model="docStatus" @change="updateDocStatus" />
      <i class="fas fa-sync text-primary fs-5 cursor-pointer" role="button" @click="loadDocuments" :class="{ 'fa-spin': isLoading }" title="Sync Documents" ></i>
      <i class="fas fa-trash-alt text-danger fs-5 cursor-pointer" role="button" @click="deleteDocuments" title="Clear Documents" ></i>
    </div>
    <div v-if="documents.length" class="mt-3 rounded p-2">
      <ul class="list-unstyled mb-0 me-1">
        <li v-for="(doc, index) in documents" :key="index">
          <a :href="getDocUrl(doc)" target="_blank" class="text-primary text-decoration-none cursor-pointer" >
            {{ doc.name || doc.url?.substring(doc.url.lastIndexOf('/') + 1) }}
          </a><i class="fas fa-download text-primary cursor-pointer ms-1" role="button"  @click="downloadImage(doc.path, doc.name)"></i>
        </li>
      </ul>
    </div>
  </div>
</div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"  > Close </button>
      </div>
    </div>
  </div>
</div>

</template>
<script setup>
import { api } from '@/utils/helpers.js';
import DocScanner from "@/components/Common/DocScanner.vue"; 
import CapturePhoto from "@/components/Common/CapturePhoto.vue";
import { ref, onMounted, computed, onBeforeUnmount} from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { schoolStore } from '@/utils/schoolStore';
const {  profile} = schoolStore();
const store = useStore()
const userId = store.state.userID;
const route = useRoute()
const isActive = (item) => {
  return route.path === item.path;
}
 const docStatus = ref(false);
 const documents = ref([]);
    const isLoading = ref(false);
const captureRef = ref(null)
const Profiles= ref([])
const logo_default = "/images/Logo.png"
const profile_default="/images/default.png"
const  sidebarLinks = ref( [
      {
        label: "Dashboard",
        icon: "fas fa-home",
        path: "/dashboard"
      },
      {
        label: "Student",
        icon: "fas fa-user",
        children: [
          { label: "Student List",icon: "fas fa-user-tie",path: "/students", },
          { label: "Parent List", icon: "fas fa-user-o", path: "/parent" },
          { label: "Export Student", icon: "fas fa-user-plus", path: "/export" },
          { label: "Promote Student", icon: "fa fa-sellsy", path: "/promote" },
          { label: "SSC Pass", icon: "fas fa-user-graduate", path: "/sscpass" },
          { label: "ID Card", icon: "fas fa-id-card-alt", path: "/idcard" },
          { label: "Hall Ticket", icon: "fas fa-address-card", path: "/hallticket" },
          { label: "Birthday", icon: "fas fa-birthday-cake", path: "/birthday" },
           { label: "Book List", icon: "fas fa-book", path: "/booklist" },
        ]
      },
      {
        label: "Teacher",
        icon: "fas fa-chalkboard-teacher",
        children: [
          { label: "Teacher List", icon: "fas fa-chalkboard-teacher", path: "/teachers" },
          { label: "Teacher ID", icon: "fas fa-id-card", path: "/teacheridcard" }
        ]
      },
     {
        label: "Academics",
        icon: "fas fa-book",
        children: [
          { label: "Class", icon: "fas fa-chalkboard", path: "/cls" },
          { label: "Subject", icon: "fas fa-book-open", path: "/subject" },
          { label: "Batch", icon: "fas fa-users", path: "/batch" },
          { label: "Category", icon: "fas fa-tag", path: "/category" },
          { label: "Class Timetable", icon: "fas fa-calendar", path: "/classtimetable" },
          { label: "Attendance", icon: "fas fa-calendar-check-o", path: "/attendance" },
          { label: "Homework", icon: "fas fa-book", path: "/homework" }
        ]
      },
      {
        label: "Examination",
        icon: "far fa-calendar-alt",
        children: [
          { label: "Exam Type", icon: "fas fa-paste", path: "/examtype" },
          { label: "Exam Setup", icon: "fas fa-calendar", path: "/examsetup" },
          { label: "Exam Timetable", icon: "far fa-calendar-plus", path: "/examtimetable" },
          { label: "Marks", icon: "	fa fa-chart-line", path: "/marks" },
          { label: "Grade", icon: "fa fa-file-text", path: "/grade" }
        ]
      },
      {
        label: "Fee Management",
        icon: "fas fa-money-bill",
        children: [
          { label: "Add Fee", icon: "fas fa-money-bill-wave", path: "/fee" },
          { label: "Fee Group", icon: "fas fa-donate", path: "/feesgroup" },
          { label: "Collect Fee", icon: "fas fa-money-check-alt", path: "/collect" },
          { label: "Payment Details", icon: "fas fa-file-alt", path: "/payment" }
        ]
      },
      {
        label: "Staff Management",
        icon: "fas fa-users",
        children: [
          { label: "Staff", icon: "fas fa-users", path: "/staff" },
          { label: "Staff ID", icon: "fas fa-address-card", path: "/staffidcard" },
          {label: "User List", icon: "fas fa-users", path: "/userlist"},
          { label: "Apply Leave", icon: "fas fa-file-text", path: "/applyleave" },
          { label: "Appointment", icon: "fas fa-clipboard-check", path: "/appointment" },
          { label: "Access", icon: "fas fa-shield-alt", path: "/access" }
        ]
      },
      {
        label: "Events & Notices",
        icon: "fas fa-microphone-alt",
        children: [
          { label: "Announcement", icon: "fas fa-microphone-alt", path: "/announcement" },
          { label: "Festival", icon: "fa fa-magic", path: "/festival" },
          { label: "Holiday", icon: "	fas fa-umbrella-beach", path: "/holiday" },
          { label: "News", icon: "fa fa-newspaper-o", path: "/news" },
          { label: "Banners", icon: "fa fa-image", path: "/banners" }
        ]
      },
      {
        label: "Support",
        icon: "fas fa-headset",
        children: [
          { label: "Complaint", icon: "fas fa-exclamation-circle", path: "/complaint" },
          { label: "Enquiry", icon: "	fas fa-phone-volume", path: "/enquiry" },
          { label: "Reminders", icon: "fas fa-bell", path: "/reminders" },
          { label: "Help", icon: "fas fa-phone", path: "/help" },
          { label: "Contacts", icon: "fas fa-address-book", path: "/contactlist" },
          { label: "Info", icon: "fas fa-file-text-o", path: "/info" },
        ]
      },
      {
        label: "Report",
        icon: "fas fa-file-text",
        children: [
          { label: "Attendance", icon: "fas fa-calendar", path: "/attndreport" },
          { label: "Awards", icon: "fas fa-award", path: "/awards" },
          { label: "Student", icon: "fas fa-user-graduate", path: "/studentreport" },
           { label: "Id Card List", icon: "fas fa-id-card", path: "/idcardlist" },
          { label: "BulkFiles", icon: "fa-solid fa-cloud-arrow-up", path: "/bulkfiles" },
        ]

      },
      {
        label: "Others",
        icon: "fas fa-cogs",
        children: [
          { label: "Transport", icon: "fas fa-bus", path: "/transport" },
           { label: "Notifications", icon: "fas fa-bell", path: "/notifications" },
          { label: "General Settings", icon: "fas fa-school", path: "/generalsetting" }
        ]
      },
       { label: "Logout", icon: "fas fa-sign-out", path: "/login" }
    ])
const bootstrapColors = [
  'text-danger',
  'text-warning',
  'text-success',
  'text-primary',
  'text-info',
  'text-secondary',
  'text-dark'
]

const nameWords = computed(() => {
    return profile.value?.Name
    ? profile.value.Name.split(' ')
    : []
})
const enforceSidebarRules = () => {
  const isDesktopLike = window.innerWidth >= 1024 || window.devicePixelRatio > 1;
  if (isDesktopLike) {
    const btn = document.querySelector(".button-toggle-menu");
    btn.style.marginLeft = "0px"; 
  }
  if (isDesktopLike) {
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("sidebar-collapsed");
  } else {
    document.body.classList.remove("sidebar-collapsed");
    document.body.classList.remove("sidebar-enable");
  }
};
window.addEventListener("resize", enforceSidebarRules);
const toggleSidebar = () => {
  const isDesktop = window.innerWidth >= 1024;
  if (!isDesktop) {
    document.body.classList.toggle("sidebar-enable");
    const btn = document.querySelector(".button-toggle-menu");
    if (document.body.classList.contains("sidebar-enable")) {
      btn.style.marginLeft = "256px"; 
    } else {
      btn.style.marginLeft = "0px"; 
    }
    return;
  }
  document.body.classList.toggle("sidebar-collapsed");
};

const loadDocAccessStatus = async () => {
  try {
    const response = await api.get(`/docaccess`);
    docStatus.value = response.data?.status === true;
  } catch (error) {
    console.warn("Could not fetch document access status", error);
  }
};
const updateDocStatus = async () => {
  try {
    const payload = { status: docStatus.value };
    await api.put(`/docaccess`, payload);
  } catch (error) {
    console.error("Error updating document status:", error);
  }
};
const loadDocuments = async () => {
      try {
        isLoading.value = true;
        const response = await api.get(`/documents`);
        documents.value = response.data;
      } catch (error) {
        return;
      } finally {
        isLoading.value = false;
      }
    };
    const deleteDocuments = async () => {
      if (!documents.value.length) return;
        await api.delete(`/documents`);
        documents.value = []; 
    };
const toggleFullscreen = () => {
  const elem = document.documentElement;
  
  if (!document.fullscreenElement) {
    elem.requestFullscreen?.();
  } else {
    document.exitFullscreen?.();
  }
};
const loadProfiles= async()=> {
    const response = await api.get(`/Profile/${userId}`);
    Profiles.value= response.data;
}
const getDocUrl = (doc) => {
  let imgUrl = doc?.url ? doc.url : doc?.path;
  if (imgUrl.startsWith("..")) { imgUrl = imgUrl.substring(2); }
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};
const downloadImage = async (path, name = "image.jpg") => {
  if (!path) { return; }
  const url =process.env.VUE_APP_API_URL + path;
  try {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.referrerPolicy = "no-referrer";
    img.src = url;
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = () => reject("Failed to load image");
    });
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataUrl = canvas.toDataURL("image/jpeg", 1.0);
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(error);
  }
};
 const getUrl = (img, fallback) => {
  let imgUrl = !img
    ? fallback
    : img.startsWith("..")
      ? img.substring(2)
      : img;  
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
     const scrollContainer = ref(null);
onMounted(() => {enforceSidebarRules(); loadProfiles();   loadDocAccessStatus();
   const modalEl = document.getElementById("document-modal")
modalEl.addEventListener("shown.bs.modal", () => {
  if (captureRef.value?.startCamera) { captureRef.value.startCamera() }
})
modalEl.addEventListener("hidden.bs.modal", () => {
  if (captureRef.value?.resetCamera) { captureRef.value.resetCamera() }
  if (captureRef.value?.close) { captureRef.value.close() }
})
  modalEl.addEventListener("hidden.bs.modal", () => {
    captureRef.value?.clearPhoto?.();
  });
  const wrapper = scrollContainer.value.querySelector('.simplebar-content-wrapper');
  if (wrapper) {
    wrapper.scrollTop = 100;
    wrapper.addEventListener('scroll', () => {
      const thumb = scrollContainer.value.querySelector('.simplebar-scrollbar');
      if (thumb) { return; }
    });
  }
});
onBeforeUnmount(() => {
  const modalEl = document.getElementById("document-modal")
  if (modalEl) {
    modalEl.replaceWith(modalEl.cloneNode(true)) 
  }
})
</script>
